<template>

	<!-- Active Users Card -->
	<a-card :bordered="false" class="dashboard-bar-chart">
		<a-spin :spinning="loading">
			<div v-if="isEmpty" class="bar-empty" :style="{ height: '220px' }">
				<div class="chart-empty">
					<a-icon type="bar-chart" class="chart-empty-icon chart-empty-icon--bar" />
					<p class="chart-empty-title">{{ emptyTitle }}</p>
					<p class="chart-empty-desc">{{ emptyDesc }}</p>
				</div>
			</div>
			<chart-bar v-else :height="220" :data="barChartData"></chart-bar>
			<div class="card-title">
				<h6>斗篷流量统计</h6>
			</div>
			<div class="card-content">
				<p>流量过滤概览</p>
			</div>
			<a-row class="card-footer" type="flex" justify="center" align="top">
				<a-col :span="6">
					<h4>{{ total }}</h4>
					<span>访问量</span>
				</a-col>
				<a-col :span="6">
					<h4>{{ pass }}</h4>
					<span>放行量</span>
				</a-col>
				<a-col :span="6">
					<h4>{{ block }}</h4>
					<span>拦截量</span>
				</a-col>
			</a-row>
		</a-spin>
	</a-card>
	<!-- Active Users Card -->

</template>

<script>

	// Bar chart for "Active Users" card.
	import ChartBar from '../Charts/ChartBar' ;
	import {getActiveAnalysis} from '@/api/index'

	export default ({
		components: {
			ChartBar,
		},
		data() {
			return {
				loading: false,
				isEmpty: false,
				emptyTitle: '暂无流量数据',
				emptyDesc: '待用户访问后展示',
				// Data for bar chart.
				barChartData: {
					labels: [],
					datasets: [],
				},
				block:0,
				pass:0,
				total:0
			}
		},
		mounted(){
			this.loading = true
			getActiveAnalysis().then(res=>{
				// 后端实测可能返回 data:[] 或 null，做对象与字段防御
				const data = res && res.data
				const labels = data && data.user
				const active = data && data.active

				// res.data 非有效对象，或缺少绘图所需的标签/数据时展示业务空态
				if (!data || Array.isArray(data) || !Array.isArray(labels) || labels.length === 0 || !Array.isArray(active) || active.length === 0) {
					this.showEmptyState()
					return
				}

				this.isEmpty = false
				this.barChartData = {
					labels: labels,
					datasets: [{
						label: "放行数",
						backgroundColor: '#1890ff',
						borderWidth: 0,
						borderSkipped: false,
						borderRadius: 6,
						data: active,
						maxBarThickness: 20,
					}],
				}
				// footer 数字安全兜底为 0，避免 undefined 渲染
				this.pass = data.pass || 0
				this.block = data.block || 0
				this.total = data.total || 0
			}).catch(()=>{
				// 请求失败同样展示空态，不渲染裸渐变占位图
				this.showEmptyState()
			}).finally(()=>{
				this.loading = false
			})
		},
		methods: {
			showEmptyState(){
				this.isEmpty = true
				this.barChartData = { labels: [], datasets: [] }
				this.pass = 0
				this.block = 0
				this.total = 0
			}
		}
	})

</script>

<style lang="scss" scoped>
	.bar-empty {
		display: flex;
		align-items: center;
		justify-content: center;
	}

	/* 业务空态：bar-chart 图标 + 标题 + 说明（对齐同页拦截趋势卡 trend-empty 风格，去 ant 库存插画） */
	.chart-empty {
		padding: 12px 16px;
		text-align: center;
	}

	.chart-empty-icon {
		font-size: 40px;
		margin-bottom: 12px;
		opacity: 0.9;
	}

	.chart-empty-icon--bar {
		color: #1890ff;
	}

	.chart-empty-title {
		margin: 0 0 6px;
		font-size: 15px;
		font-weight: 600;
		color: #3b4a66;
	}

	.chart-empty-desc {
		margin: 0;
		font-size: 13px;
		color: #8c98ad;
	}
</style>
